import { useEffect, useState } from "react";
import { Player } from "../../../domain/model/User";
import { UploadFileUseCase } from "../../../domain/usecase/uploadFile/UploadFileUseCase";
import { Attachment } from "../../../domain/model/Attachment";
import { useSnackbar } from "notistack";
import { State } from "../../../domain/model/ResponseState";
import { UpdatePlayerUseCase } from "../../../domain/usecase/player/Update/UpdateUseCase";
import {
  getUserInfoAgain,
  showGlobalLoadingView,
} from "../../../core/utils/Utils";
import { PlayerGetCurrentReferralUnlockedCodesUseCase } from "../../../domain/usecase/player/GetCurrentReferralUnlockedCodes/GetCurrentReferralUnlockedCodesUseCase";
import { CategoryUnlockCode } from "../../../domain/model/Category";

export function ProfileViewModel(
  uploadFileUseCase: UploadFileUseCase,
  updatePlayerUseCase: UpdatePlayerUseCase,
  getPlayerReferralUnlockedCodesUseCase: PlayerGetCurrentReferralUnlockedCodesUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [player, setPlayer] = useState<Player | undefined>();

  const [referralCodesLoading, setReferralCodesLoading] = useState(false);
  const [referralCodes, setReferralCodes] = useState<Array<CategoryUnlockCode>>(
    []
  );
  const [profileImageFile, setProfileImageFile] = useState<File | undefined>();

  useEffect(() => {
    getCurrentUserReferralUnlockedCodes();
  }, []);
  async function applyChanges() {
    const currentPlayer = { ...player };
    if (!currentPlayer) return;

    showGlobalLoadingView(true);
    if (profileImageFile) {
      const attachment = await uploadFile(profileImageFile);
      if (!attachment) return;
      currentPlayer.profileImage = attachment?.downloadUrl;
    }
    const response = await updatePlayerUseCase.invoke(currentPlayer);
    switch (response.responseState) {
      case State.Success:
        getUserInfoAgain();
        showSnackbar(response.data?.message, "success");
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    showGlobalLoadingView(false);
  }

  async function getCurrentUserReferralUnlockedCodes() {
    setReferralCodesLoading(true);
    const response = await getPlayerReferralUnlockedCodesUseCase.invoke();
    setReferralCodesLoading(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        setReferralCodes(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function uploadFile(file: File): Promise<Attachment | undefined> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await uploadFileUseCase.invoke(formData);
    switch (response.responseState) {
      case State.Success:
        return response.data;
      case State.Fail:
      case State.Error:
        showGlobalLoadingView(false);
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    player,
    setPlayer,
    profileImageFile,
    setProfileImageFile,
    applyChanges,
    referralCodes,
    referralCodesLoading
  };
}
